import { ROUTES } from "../constants";
export const defaultState = {
    page: ROUTES.HOME_PAGE,
    saleData: null,
    loginConfig: null,
    language: "en",
};
